var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyegreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93983 8.78182C1.71211 8.28642 1.71211 7.71489 1.93983 7.21948C2.9939 4.92627 5.31122 3.33398 8.00044 3.33398C10.6897 3.33398 13.007 4.92627 14.0611 7.21948C14.2888 7.71489 14.2888 8.28642 14.0611 8.78183C13.007 11.075 10.6897 12.6673 8.00044 12.6673C5.31122 12.6673 2.9939 11.075 1.93983 8.78182Z",
    stroke: "#2EBF43",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 8.00065C10.0004 9.10522 9.10501 10.0007 8.00044 10.0007C6.89588 10.0007 6.00044 9.10522 6.00044 8.00065C6.00044 6.89608 6.89588 6.00065 8.00044 6.00065C9.10501 6.00065 10.0004 6.89608 10.0004 8.00065Z",
    stroke: "#2EBF43",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyegreen);
export default __webpack_public_path__ + "static/media/eyegreen.697b1455c1a508338a45f49fc76ae0fd.svg";
export { ForwardRef as ReactComponent };